module.exports = __webpack_public_path__ + "img/widgetabout-6.65f41a67.jpg";